import { OmitType, PartialType } from '@nestjs/swagger';
import { CreateProductoEspecificacionDto } from './create-producto-especificacion.dto';

/** El producto de una especificación no se reasigna: se elimina y se vuelve a crear. */
export class UpdateProductoEspecificacionDto extends PartialType(
  OmitType(CreateProductoEspecificacionDto, ['producto_id'] as const),
) {}
